export default "__VITE_ASSET__DlQPih_m__"